import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';
import Canvas from './pages/Canvas';
import Content from './pages/Content';
import Daily from './pages/Daily';
import Dashboard from './pages/Dashboard';
import Friends from './pages/Friends';
import Home from './pages/Home';
import Login from './pages/Login';
import Marketplace from './pages/Marketplace';
import Moderation from './pages/Moderation';
import NotFound from './pages/NotFound';
import Notifications from './pages/Notifications';
import Pages from './pages/Pages';
import Problems from './pages/Problems';
import ProblemsSearch from './pages/ProblemsSearch';
import PublicProfile from './pages/PublicProfile';
import PublicPages from './pages/PublicPages';
import PublicStory from './pages/PublicStory';
import Settings from './pages/Settings';
import Social from './pages/Social';
import Stories from './pages/Stories';
import Timeline from './pages/Timeline';
import './styles/global.css';

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
          <Routes>
              <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Navigate to="/login" replace />} />
              <Route path="/marketplace" element={<Marketplace />} />
              <Route path="/pages" element={<Navigate to="/dashboard/pages" replace />} />
              <Route path="/u/:username" element={<ProtectedRoute><PublicProfile /></ProtectedRoute>} />
              <Route path="/u/:username/pages" element={<ProtectedRoute><PublicPages /></ProtectedRoute>} />
              <Route path="/u/:username/stories/:storyId" element={<ProtectedRoute><PublicStory /></ProtectedRoute>} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/site-theme"
                element={
                  <ProtectedRoute>
                    <Canvas />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/profile"
                element={
                  <ProtectedRoute>
                    <Navigate to="/dashboard/site-theme" replace />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/canvas"
                element={
                  <ProtectedRoute>
                    <Navigate to="/dashboard/site-theme" replace />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/suggestions"
                element={
                  <ProtectedRoute>
                    <Navigate to="/dashboard/daily" replace />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/daily"
                element={
                  <ProtectedRoute>
                    <Daily />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/components"
                element={
                  <ProtectedRoute>
                    <Navigate to="/dashboard/site-theme" replace />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/content"
                element={
                  <ProtectedRoute>
                    <Content />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/pages"
                element={
                  <ProtectedRoute>
                    <Pages />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/problems"
                element={
                  <ProtectedRoute>
                    <Problems />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/problems/search"
                element={
                  <ProtectedRoute>
                    <ProblemsSearch />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/moderation"
                element={
                  <ProtectedRoute>
                    <Moderation />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/notifications"
                element={
                  <ProtectedRoute>
                    <Notifications />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/settings"
                element={
                  <ProtectedRoute>
                    <Settings />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/social"
                element={
                  <ProtectedRoute>
                    <Social />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/friends"
                element={
                  <ProtectedRoute>
                    <Friends />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/stories"
                element={
                  <ProtectedRoute>
                    <Stories />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/timeline"
                element={
                  <ProtectedRoute>
                    <Timeline />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/widgets"
                element={
                  <ProtectedRoute>
                    <Navigate to="/dashboard/site-theme" replace />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/buddy"
                element={
                  <ProtectedRoute>
                    <Navigate to="/dashboard/daily" replace />
                  </ProtectedRoute>
                }
              />
              <Route path="/profile" element={<Navigate to="/dashboard/profile" replace />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
